import React from 'react';
import { Card } from 'react-bootstrap';
import './global.css';

const Skills = () => {
    return (

        <div className='container mt-5 overflow-hidden controlskillspace' id='skills'>
            <div className='row gx-5 gy-5'>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
                    <h2 className='text-warning text-center mt-5 mb-2'>Technologies and Skills</h2>
                    <div className="small-border mb-4 "></div>
                    <div data-aos="fade-right" data-aos-duration="2000">
                        <Card style={{ width: '26rem' }} className='shadow p-3 mb-5 bg-dark text-light rounded mx-auto font-monospace widthforrespo' >
                            <Card.Body>
                                <Card.Title className='fw-bolder' style={{ color: "khaki" }}>Expertise:</Card.Title>
                                <Card.Subtitle className="mb-2 "><p style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem" }}>JavaScript, React JS, MongoDB, Mongoose, React-Router, API, HTML, HTML5, CSS, CSS3, Web Design,
                                    Bootstrap / React Bootstrap, Material mui, Tailwind, Daisyui.</p></Card.Subtitle>
                                <Card.Title className='fw-bolder' style={{ color: "khaki" }}>Comfortable:</Card.Title>
                                <Card.Text style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem" }}>
                                    Node.JS, Express JS, Json web token (JWT), OpenAi, React-Native, Next.js, Typescript, Stripe Payment API.
                                </Card.Text>
                                <Card.Title className='fw-bolder' style={{ color: "khaki" }}>Tools:</Card.Title>
                                <Card.Text style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem" }}>
                                    Npm, Firebase, Heroku, Netlify, GitHub, Git, VS Code, Node dev tools.
                                </Card.Text>

                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
                    <h2 className='text-warning text-center mt-5 mb-2 controleducatiomspace'>Education Background</h2>
                    <div className="small-border mb-4"></div>
                    <div data-aos="fade-left" data-aos-duration="2000">
                        <Card style={{ width: '26rem' }} className='shadow p-3 mb-5 bg-dark text-light rounded mx-auto font-monospace widthforrespo handleHeightSkills ' >
                            <Card.Body>
                                <Card.Title className='fw-bolder' style={{ color: "khaki" }}>SSC 2019</Card.Title>
                                <Card.Subtitle className="mb-2 " style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem" }}>
                                    Science Department</Card.Subtitle>
                                <Card.Text style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1rem" }}>
                                    MONIPUR HIGH SCHOOL
                                </Card.Text>
                                <Card.Title className='fw-bolder' style={{ color: "khaki" }}>HSC 2021</Card.Title>
                                <Card.Subtitle className="mb-2" style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem" }}>
                                    Science Department</Card.Subtitle>
                                <Card.Text style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1rem" }}>
                                    ADAMJEE CANTONMENT COLLEGE
                                </Card.Text>
                                <Card.Title className='fw-bolder' style={{ color: "khaki" }}>Present</Card.Title>
                                <Card.Subtitle className="mb-2" style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.5rem" }}>
                                    B.Sc. in Computer Science & Engineering (CSE)</Card.Subtitle>
                                <Card.Text style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.5rem" }}>
                                    BANGLADESH UNIVERSITY OF BUSINESS AND TECHNOLOGY (BUBT)
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default Skills;